import { combineReducers } from 'redux';
import listings from './reducers/listings';

export default combineReducers({
  listings
});
